import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import "./index.css";

import { AuthContextProvider } from "./context/authContext";
import { TestContextProvider } from "./context/testContext";
import { AdminContextProvider } from "./context/adminContext";
import { router } from "./router";

 
 

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement 
);
root.render(

      <AuthContextProvider>
        <TestContextProvider>
          <AdminContextProvider>
            <RouterProvider router={router} />
          </AdminContextProvider>
        </TestContextProvider>
      </AuthContextProvider>

);
